import { OverviewApprovalItemDuration, StatisticCategory } from '../../types';
import { Bar } from '@ant-design/plots';
import * as React from 'react';
import { timeStringFromDuration } from '../../helpers';
import { antGrey, hexStringToRGBAString, runwayColors } from '../styles/globalStyles';
import Icon from '@ant-design/icons';
import { colorForStatCategory, iconForStatCategory } from '../orgOverview/orgOverviewHelpers';
import { StatInfoSectionProps, StatSection } from '../orgOverview/OrgOverviewStatCards';

const getGraphHeight = (numApprovals: number): number => {
    const maxHeight = 1000;
    const minHeight = 400;
    const heightPerRow = 14;

    const height = numApprovals * heightPerRow;
    if (height > maxHeight) {
        return maxHeight;
    }
    if (height < minHeight) {
        return minHeight;
    }
    return height;
};

const AverageApprovalsBarGraph = ({
    approvalDurations,
    numReleases,
}: {
    approvalDurations: OverviewApprovalItemDuration[];
    numReleases: number;
}) => {
    if (!approvalDurations || approvalDurations.length === 0) {
        return null;
    }
    const data = approvalDurations.map((duration) => ({
        duration: duration.averageDuration,
        approval: duration.approvalItemTitle,
    }));
    const config = {
        data,
        xField: 'duration',
        yField: 'approval',
        seriesField: 'approval',
        legend: false,
        height: getGraphHeight(data.length), // We calculate height dynamically to make sure there is enough space to display each y-axis label
        autoFit: false, // autoFit is false to allow height to be dynamically calculated
        meta: {
            duration: {
                alias: 'Time',
                formatter: (value) => {
                    return timeStringFromDuration(value);
                },
            },
        },
    };

    const tooltip = `Durations are measured from release kickoff to approval time, averaged across latest ${numReleases} releases.`;
    const upperSection: StatInfoSectionProps = {
        title: 'Approval completion times',
        value: null,
        secondaryValue: null,
        secondaryValueIcon: null,
        tooltip: tooltip,
        cardIcon: (
            <Icon
                component={iconForStatCategory(StatisticCategory.DevOps)}
                style={{
                    fontSize: 14,
                    color: colorForStatCategory(StatisticCategory.DevOps),
                }}
            />
        ),
    };

    // @ts-ignore
    const barGraph = <Bar {...config} />;
    return (
        <div
            style={{
                marginTop: '20px',
                marginBottom: '20px',
                border: '1px solid',
                borderColor: antGrey.grey4,
                borderRadius: 8,
                maxWidth: '75%',
            }}
        >
            <StatSection {...upperSection} />
            <div
                style={{
                    backgroundColor: hexStringToRGBAString(runwayColors.black, 0.02),
                    padding: '20px',
                }}
            >
                {barGraph}
            </div>
        </div>
    );
};

export { AverageApprovalsBarGraph };
